import React, { useReducer, useRef, useState } from 'react';

import { message } from 'antd';
import { inject, observer } from 'mobx-react';

import { CustomerAPI } from '@api/customer';
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import pubsub from '@lib/scripts/pubsub'
import I18n from '@utils/i18n';
import { doRequest } from '@utils/request'

import Modal from './Modal'

// eslint-disable-next-line
function reducer(state, action) {
  switch (action.type) {
    case 'update':
      return { ...state, ...action.payload };
    case 'reset':
      return {
        isCountDown: false,
        isCountDownEmail: false,
        step: 1,
        showconfim: false,
        subphone: '',
        changeOrUnbind: ''
      };
    default:
      throw new Error();
  }
}

const T = (props: any) => {
  const {
    getSafetyStore,
    userStore
  } = props

  const [modalVisible, setModalVisible] = useState(false)
  const [verifyTypes, setVerifyTypes]: any = useState({})
  const [userInfo, setUserInfo] = useState(userStore.userInfo)
  const originReqParamsRef: any = useRef({})
  const ruleRef = useRef('')
  const nextStepRef = useRef('')

  const handleVerify = ({ nextStep, rule, registerType, items, email, phone, originReqParams }) => {
    items = JSON.parse(items)
    originReqParamsRef.current = originReqParams
    ruleRef.current = rule
    nextStepRef.current = nextStep
    // const nextStep = 'REGISTER_VERIFY'
    switch (nextStep) {
      case 'FULL_VERIFY':
        setVerifyTypes({
          email: items.isEmailCertified,
          phone: items.isPhoneCertified,
          google: items.isGoogleCertified
        })
        setUserInfo({ ...userInfo, ...{ email, phone } })
        setModalVisible(true)
        break;
      case 'GOOGLE_VERIFY':
        setVerifyTypes({
          google: true
        })
        setUserInfo({ ...userInfo, ...{ email, phone } })
        setModalVisible(true)
        break;
      case 'REGISTER_VERIFY':
        setVerifyTypes({
          phone: registerType === 1,
          email: registerType === 2
        })
        setUserInfo({ ...userInfo, ...{ email, phone } })
        setModalVisible(true)
        break;
    }
  }
  useIsomorphicLayoutEffect(() => {
    pubsub.subscribe('DEVICE_RISK_VERIFY', handleVerify)
    return () => {
      pubsub.unSubscribe('DEVICE_RISK_VERIFY', handleVerify)
    }
  }, [userInfo])

  const onNext = (token) => {
    // eslint-disable-next-line
    const { method, url, opts, data } = originReqParamsRef.current
    const riskToken = `${ruleRef.current}:${token}`;
    if (typeof opts.device_risk_type !== 'undefined' && typeof riskToken !== 'undefined') {
      const params = {
        data: data,
        opts: {
          ...opts, ...{ headers: { risk_token: riskToken } }
        }
      }
      pubsub.publish(`DEVICE_RISK_VERIFY_PASS_${opts.device_risk_type}`, params)
    } else {
      doRequest(method, url, { ...opts, ...{ headers: { risk_token: `${ruleRef.current}:${token}` } } }, data)
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    isCountDown: false,
    isCountDownEmail: false,
    step: 1,
    isSucess: false,
    validateStatus: ''
  });

  const loginDisabledFn = (form) => {
    const forValue = Object.values(form.getFieldsValue())
    const formvalueisExist = forValue.length > 0 ? forValue.every(i => i) : false
    const errors = form.getFieldsError()?.reduce((prev, curr) => {
      prev.push(...curr.errors)
      return prev;
    }, []);
    return formvalueisExist && !errors.length
  }

  const onResend = (type) => {
    if (type === 'phone') {
      getSafetyStore.sendVerifyCode({
        // type:
        email: '',
        mobile: encodeURIComponent(userInfo.phone),
        type: 23,
        businessType: 23
      }).then((res) => {
        if (res) {
          dispatch({
            type: 'update',
            payload: {
              isCountDown: true
            }
          })
        }
      })
      return
    }
    getSafetyStore.sendVerifyCode({
      // type:
      email: userInfo.email,
      mobile: '',
      type: 23,
      businessType: 23
    }).then(res => {
      if (res) {
        dispatch({
          type: 'update',
          payload: {
            isCountDownEmail: true
          }
        })
      }
    })
  }

  const onFinish = async (value, form) => {
    if (nextStepRef.current === 'REGISTER_VERIFY') {
      const email = verifyTypes?.email ? userInfo.email : '';
      const phone = verifyTypes?.phone ? userInfo.phone : '';
      const res = await CustomerAPI.verifyCode({
        type: '23',
        email: email,
        mobile: encodeURIComponent(phone),
        verifyCode: Object.values(value)?.[0]
      })
      if (res.success) {
        onNext(res.obj)
        closeModal(form)
      } else {
        message.error(I18n.t(res.msgKey), 2);
      }
    } else {
      getSafetyStore.getfull({
        type: '23',
        email: userInfo.email,
        phone: encodeURIComponent(userInfo.phone),
        ...value
      }).then(res => {
        onNext(res)
        closeModal(form)
      })
    }
  }

  const closeModal = (form) => {
    dispatch({
      type: 'reset'
    })
    form.resetFields()
    setModalVisible(false)
  }

  if (!userStore.userInfo) return null

  return (
    <Modal
      getSafetyStore={getSafetyStore}
      verifyTypes={verifyTypes}
      userInfo={userInfo}
      modalVisible={modalVisible}
      setModalVisible={setModalVisible}
      loginDisabledFn={loginDisabledFn}
      closeModal={closeModal}
      onFinish={onFinish}
      onResend={onResend}
      state={state}
      dispatch={dispatch}
    />

  )
}

export default inject((rootStore: any) => {
  return {
    userStore: rootStore.store.userStore,
    getSafetyStore: rootStore.store.getSafetyStore
  };
})(observer(T))
